<template>
  <van-dialog
    v-model="data.isNeed"
    :title="'尚未关注'+GetSysTitle()"
    show-cancel-button
    cancel-button-text="暂不关注"
    confirm-button-text="已经关注"
    @confirm="onConfirm"
    @cancel="onCancel"
    @closed="onClosed"
  >
    <img class="qrIcon" :src="data.url">
    <div v-if="!data.wxBiz || isIOS" class="about"> 为了能够更好的为您服务，请先关注<b>{{ data.wxName }}</b>！</div>
  </van-dialog>

</template>
<script>
import request from '@/utils/request'
import { Dialog, Button } from 'vant'
import { GetSysTitle, getUrlKey } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import router from '@/router'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
  },
  data() {
    return {
      loading: false,
      data: {
        isNeed: false,
        url: '',
        type: 'DIVEBOSS',
        wxName: '',
        wxBiz: '',
        isIOS: false
      }
    }
  },
  watch: {
    value(newValue) {
      console.log('激活是否关注公众号检查')
      if (newValue) {
        this.$emit('input', false)
        this.init()
        this.showDialog = true
      }
    }

  },
  created() {
    var u = navigator.userAgent
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  },
  methods: {
    GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine,
    GetSysTitle,
    init() {
      if (this.loading) {
        return
      }
      this.loading = true
      request({
        url: '/user/checkUserFollowWx',
        method: 'post'
      }).then(response => {
        this.loading = false
        // this.$emit('finish', false)
        if (!response.success) {
          return
        }
        this.data = response.data
        // this.data.url = null
        if (!this.data.url) {
          if (this.data.type === 'DIVEBOSS') {
            this.data.url = '/img/divebossWx.jpg'
          } else {
            this.data.url = '/img/emptyWx.jpg'
          }
        }
        if (!this.data.isNeed) {
          this.$emit('finish')
        }
      })
    },
    // onFollowWx() {
    //   window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=' + this.data.wxBiz + '&scene=110#wechat_redirect'
    // },
    onConfirm() {
      if (this.loading) {
        return
      }
      this.loading = true
      const base32 = require('base32')
      var system = getUrlKey('system')
      var Backrouter = router.history.current.fullPath
      // "http://192.168.2.51:8080/loginCallbackThird?system=cooldive&url=5xpqjbv3d1jp6uu3cnt6jtk9cdgq8t9zedwq6x35dmyp6vvfdhj6jxk54tu3uc9n6wt3ec9q6gw3ce1t68"
      var url = GetSelfUrl() + 'loginCallbackThirdInfo?system=' + system + '&url=' + base32.encode(Backrouter)
      request({
        url: '/user/reCheckUserFollowWx',
        method: 'post',
        data: {
          url: url
        }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        window.location.href = response.data
        this.showDialog = false
      })
    },
    onCancel() {
      this.showDialog = false
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/store/index')
    },
    onClosed() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.about{
    padding:0 1em 1em 1em;
    font-size: 0.8em;
    color: #999;
    text-align: center;
}
.qrIcon{
  width: 100%;
  position: relative;
  z-index: 100;
  -webkit-user-select: none;
}
</style>
